<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13L13 1M1 1L13 13"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "14",
  },
  height: {
    type: [String, Number],
    default: "14",
  },
  color: {
    type: String,
    default: "#3B4648",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
